/**
 * Toggles a key in an expanded-keys list (multi-open accordion).
 * Opening one key does not close the others.
 *
 * @param {string[]} currentKeys
 * @param {string} key
 * @returns {string[]}
 */
export function toggleExpandedKey(currentKeys, key) {
  const keys = Array.isArray(currentKeys) ? currentKeys : [];
  const target = String(key ?? "");
  if (target.length === 0) {
    return keys;
  }
  if (keys.includes(target)) {
    return keys.filter((entry) => entry !== target);
  }
  return [...keys, target];
}

/**
 * Ensures a key is present without removing others.
 *
 * @param {string[]} currentKeys
 * @param {string} key
 * @returns {string[]}
 */
export function ensureExpandedKey(currentKeys, key) {
  const keys = Array.isArray(currentKeys) ? currentKeys : [];
  const target = String(key ?? "");
  if (target.length === 0 || keys.includes(target)) {
    return keys;
  }
  return [...keys, target];
}
